import { FALLBACK_LANG, type Lang } from "../i18n/index";
import type { ScaleMode } from "../render/index";

export type MenuTab = "controls" | "bodies" | "help";

export const MENU_TABS: readonly MenuTab[] = ["controls", "bodies", "help"];

export type InfoTab = "overview" | "body" | "orbit";

export const INFO_TABS: readonly InfoTab[] = ["overview", "body", "orbit"];

export interface ViewState {
  focus: string;
  scale: ScaleMode;
  labels: boolean;
  orbits: boolean;
  stats: boolean;
  /** Overlay state from here on is session-only and never reaches the URL hash. */
  menuOpen: boolean;
  menuTab: MenuTab;
  infoExpanded: boolean;
  infoTab: InfoTab;
  /** Kept in local storage by the app, not in the hash. */
  lang: Lang;
}

export const DEFAULT_STATE: ViewState = {
  focus: "sun",
  scale: "visual",
  labels: false,
  orbits: true,
  stats: false,
  menuOpen: false,
  menuTab: "controls",
  infoExpanded: false,
  infoTab: "overview",
  lang: FALLBACK_LANG,
};

type Listener = (s: ViewState) => void;

export class Store {
  readonly state: ViewState = { ...DEFAULT_STATE };
  private readonly listeners = new Set<Listener>();

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  set(partial: Partial<ViewState>): void {
    // the menu card and the info card share the middle of the screen, so opening the menu folds the card
    if (partial.menuOpen) partial = { ...partial, infoExpanded: false };
    let changed = false;
    for (const key of Object.keys(partial) as (keyof ViewState)[]) {
      const value = partial[key];
      if (value !== undefined && value !== this.state[key]) {
        Object.assign(this.state, { [key]: value });
        changed = true;
      }
    }
    if (changed) for (const fn of this.listeners) fn(this.state);
  }
}
